import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  disabled: {
    '& .MuiInputBase-input.Mui-disabled': {
      cursor: 'not-allowed',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      cursor: 'not-allowed',
    },
  },

  size: {
    '& .MuiInputBase-root': {
      fontSize: { xs: '1.1rem', sm: '1rem' },
      height: { xs: '32px', sm: 'auto' },
      '& input': {
        padding: { xs: '16.5px 14px', sm: '8px 10px' },
      },
    },
    '& .MuiInputLabel-root': {
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      lineHeight: 1.2,
      maxWidth: '100%',
    },
  },
};
